import { currenciesZodSchema } from '@mint-lib/currencies-helpers';
import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const MediaPlanGoalsSchema = z.record(
  z.string(),
  z.coerce.number().nullable(),
);

export const CreatePlanRequestSchema = z.object({
  name: z.string(),
  budget: z.number(),
  currency: currenciesZodSchema,
  dateFrom: z.string(),
  dateTo: z.string(),
  description: z.string(),
  permissionTags: z.array(z.string()),
  goals: MediaPlanGoalsSchema,
});

export const CreatePlanResponseSchema = createResponseSchema(
  z.object({
    id: z.string(),
    name: z.string(),
    currency: currenciesZodSchema,
    createdBy: z.number(),
    updatedBy: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    workspaceId: z.number(),
    isDeleted: z.boolean(),
    mediaDataId: z.string(),
  }),
);

export const PlanNameValidationQuerySchema = z.object({
  name: z.string(),
  mediaPlanId: z.string().optional(),
});

export const PlanNameValidationResponseSchema = createResponseSchema(
  z.object({
    isValid: z.boolean(),
  }),
);

export const GetPlanResponseSchema = createResponseSchema(
  z.object({
    createdBy: z.number(),
    updatedBy: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    id: z.string(),
    name: z.string(),
    workspaceId: z.number(),
    isDeleted: z.boolean(),
    currency: currenciesZodSchema,
    budget: z.coerce.number(),
    dateFrom: z.string(),
    dateTo: z.string(),
    description: z.string(),
    mediaDataId: z.string(),
    goals: MediaPlanGoalsSchema.default({}),
  }),
);

export const UpdatePlanRequestSchema = z.object({
  name: z.string().optional(),
  budget: z.coerce.number().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  description: z.string().optional(),
  columns: z.array(z.string()).optional(),
  goals: MediaPlanGoalsSchema.optional(),
});

export const UpdatePlanResponseSchema = createResponseSchema(
  UpdatePlanRequestSchema,
);

export const RemoveMediaPlansRequestSchema = z.object({
  mediaPlanIds: z.array(z.string()),
});

export const GetMediaPlansPreviewResponseSchema = z.object({
  data: z.object({
    items: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
      }),
    ),
  }),
});

export const GetMediaPlansPreviewQuerySchema = z.object({
  withConfiguredMediaRows: z.boolean().optional(),
});

export const GetActivitiesPreviewQuerySchema = z.object({
  mediaPlanId: z.string(),
  withConfiguredMediaRows: z.boolean().optional(),
});

export const GetActivitiesPreviewResponseSchema = z.object({
  data: z.object({
    items: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
      }),
    ),
  }),
});
